import React from 'react';
import { formatDate } from '../../../../util';
import BlogContent from './BlogContent';
import BlogDetails from './BlogDetails';
import BlogSocials from './BlogSocials';
import Col from '../../../layout/Col';
import Container from '../../../layout/Container';
import Grid from '../../../layout/Grid';
import Heading from '../../../Heading';
import Image from '../../../Image';
import Layout from '../../../layout/Layout';
import useArticle from '../../../../hooks/useArticle';
import Sections from '../../../layout/Sections';
import { Seo } from '../../../seo/Seo';
import NotFound from '../../../NotFound';
import {useRouter} from 'react-router5';
import { canonicalDomain } from '../../../seo/DefaultSeo';
import removeMarkdown from 'remove-markdown';
import BlogRelated from './BlogRelated';
import { defaultLanguage } from '../../../../routerMiddleware';

export default function BlogView() {
  const article = useArticle();
  const router = useRouter();

  if (!article) {
    return <NotFound />;
  }

  const url = canonicalDomain + router.buildPath('blog.view', {
    lang: defaultLanguage,
    id: article.id,
    slug: article.slug,
  });
  const image = article.image ? canonicalDomain + article.image : null;
  const cardType = article.image ? 'summary_large_image' : 'summary';
        
  return (
    <Layout paddingBottom="0">
      <Seo
        title={`${article.title} - Blog - Tweede golf`}
        description={removeMarkdown(article.summary)}
        image={image}
      >
        <link rel="canonical" href={url === 'https://tweedegolf.nl/en/blog/128/rust-in-ten-years' ? 'https://corrode.dev/blog/rust-in-ten-years' : url} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="article" />
        <meta name="author" content={article.authors.map((a) => a.name).join(', ')} />
        <meta name="publish_date" property="og:publish_date" content={article.date.toString()} />
        <meta name="twitter:card" content={cardType} />
      </Seo>
      <Container>
        <Grid $cols={{ lg: 12 }} $columnGap="gutter">
          <Col $col={{ lg: '2 / span 10', xl: '3 / span 8' }}>
            <Sections $rowGap="baseline">
              <div>
                <Heading as="time" $bold $color="pastel-green-400" dateTime={article.date.toString()}>
                  {formatDate(article.date)}
                </Heading>
                <Heading>{article.title}</Heading>
              </div>
              <div>
                <BlogDetails
                  users={article.authors}
                  tags={article.tags}
                />
                {article.image && (
                  <Image
                    src={article.image}
                    alt={article.title}
                  />
                )}
                <BlogContent content={article.content} summary={article.summary} />
                <BlogDetails
                  withEmail
                  users={article.authors}
                  tags={article.tags}
                />
                <BlogSocials />
              </div>
            </Sections>
          </Col>
        </Grid>
      </Container>
      <BlogRelated/>
    </Layout>
  );
}
